import { lazy } from 'react'

const Signup = lazy(() => import('../../features/auth/pages/Signup/Signup'))
const Login = lazy(() => import('../../features/auth/pages/Login/Login'))
const SignupSuccess = lazy(
  () => import('../../features/auth/pages/Signup/SignupSuccess'),
)
const SelectRole = lazy(
  () => import('../../features/auth/pages/SelectRole/SelectRole'),
)

const ForgotPassword = lazy(
  () =>
    import('../../features/auth/pages/ForgotPassword/ForgotPasswordRequest'),
)
const ForgotPasswordSuccess = lazy(
  () =>
    import(
      '../../features/auth/pages/ForgotPassword/ForgotPasswordRequestSuccess'
    ),
)
const ResetPassword = lazy(
  () => import('../../features/auth/pages/ForgotPassword/ResetPassword'),
)
const ResetPasswordSuccess = lazy(
  () => import('../../features/auth/pages/ForgotPassword/ResetPasswordSuccess'),
)
const ForgotPasswordLinkExpired = lazy(
  () =>
    import(
      '../../features/auth/pages/ForgotPassword/ForgotPasswordLinkExpired'
    ),
)

const PublicRoutes = [
  { path: '/signup', element: <Signup /> },
  { path: '/specify/role/:id', element: <SelectRole /> },
  { path: '/signup/success', element: <SignupSuccess /> },
  { path: '/login', element: <Login /> },
  { path: '/password/forgot', element: <ForgotPassword /> },
  { path: '/password/forgot/success', element: <ForgotPasswordSuccess /> },
  { path: '/password/reset/:id', element: <ResetPassword /> },
  { path: '/password/reset/success', element: <ResetPasswordSuccess /> },
  { path: '/link/expired', element: <ForgotPasswordLinkExpired /> },
]

export default PublicRoutes
